import React from 'react';

import { showLogNoTime } from '@libs/NwMoment';

import { UPLOAD_CONTENT_TYPE } from '@containers/Art/Uploads/Uploads.constants';
import { UploadsGridTileButton } from '@containers/Art/Uploads/UploadsGrid.styles';
import UploadTilePreview from '@containers/Art/Uploads/UploadTilePreview';

const getUploadTypeLabel = (upload) => {
    if (upload.Type === UPLOAD_CONTENT_TYPE.WEB_VIDEO) return 'Video';
    if (upload.Type === UPLOAD_CONTENT_TYPE.WEB_DOCUMENT) return 'File';
    return 'Picture';
};

const UploadsGridTile = ({ badge, isSelected, onClick, upload }) => {
    const uploadType = getUploadTypeLabel(upload);
    const uploadDate = upload.UploadedAt ? showLogNoTime(upload.UploadedAt) : '';
    const uploadMeta = uploadDate ? `${uploadType} - Updated at ${uploadDate}` : uploadType;

    return (
        <UploadsGridTileButton
            className={isSelected ? 'is-selected' : ''}
            type="button"
            onClick={() => onClick(upload)}
        >
            <div className="upload-tile-thumb-wrap">
                <div className="upload-tile-thumb">
                    <UploadTilePreview upload={upload} />
                </div>
                {badge}
            </div>
            <div className="upload-tile-title">{upload.Title}</div>
            <div className="upload-tile-meta">{uploadMeta}</div>
        </UploadsGridTileButton>
    );
};

export default UploadsGridTile;
